export default "__VITE_ASSET__Cbf8gGc9__"